import { LoadableAfterPaint } from '@confluence/loadable';

export const StandaloneRestrictedPageOrSpace = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-StandaloneRestrictedPageOrSpace" */ './StandaloneRestrictedPageOrSpace'
			)
		).StandaloneRestrictedPageOrSpace,
});
